// extracted by mini-css-extract-plugin
export default {"root":"AddressForm_root__1E2Gj","fields":"AddressForm_fields__a-Y5G","side":"AddressForm_side__Utx-m","error":"AddressForm_error__c27PR"};